<div class="container mt-5">
    <div class="row">
        <div class="col-lg-12">
            <h1 class="text-center">Choose Parking</h1>
        </div>
    </div>
    <div class="row justify-content-center">
        <!--        <div class="col-md-3">-->
        <!--            <div class="card w-100 m-3 rounded-3" (click)="selectParkingType(parkingTypes.PARKING_EVENTS)">-->
        <!--                <div class="card-header">-->
        <!--                    <div class="card-img-top">-->
        <!--                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-events.png">-->
        <!--                    </div>-->
        <!--                    <h4 class="card-title">-->
        <!--                        ParkUpp Events-->
        <!--                    </h4>-->
        <!--                </div>-->
        <!--                <div class="card-body">-->
        <!--                    <div class="card-subtitle">-->
        <!--                        If you have secure A grade parking within safe walking distance of an upcoming event, then list-->
        <!--                        here. List for a specific event, include its date, parkers can book, pay and park for the-->
        <!--                        duration of that specific event plus two hours either side only. ParkUpp will promote on an-->
        <!--                        event by event basis.-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="col-md-3">
            <div class="card w-100 m-3 rounded-3" (click)="selectParkingType(parkingTypes.STANDARD)">
                <div class="card-header">
                    <div class="card-img-top">
                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-monthly.png" />
                    </div>
                    <h4 class="card-title">ParkUpp Monthly</h4>
                </div>
                <div class="card-body">
                    <div class="card-subtitle">
                        “A grade”, secure, parking. Basement, covered or open. Choose to list for next day, by the month and or annual parking contracts. Depends on how short or long you would like
                        parkers to park for. Corporate and personal parkers
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card w-100 m-3 rounded-3" (click)="selectParkingType(parkingTypes.PARKING_COLLECTOR)">
                <div class="card-header">
                    <div class="card-img-top">
                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-collector.png" />
                    </div>
                    <h4 class="card-title">ParkUpp Collector</h4>
                </div>
                <div class="card-body">
                    <div class="card-subtitle">
                        Whether a specialised, service or premium grade secure parking, if your facility is suitable to house collector, performance or signature cars, this is the place to list. This
                        category is for hi-value vehicles
                    </div>
                </div>
            </div>
        </div>
        <!--        <div class="col-md-3">-->
        <!--            <div class="card w-100 m-3 rounded-3 coming-soon"-->
        <!--                 (click)="selectParkingType(parkingTypes.PLANES_TRAINS_SHIPS)">-->
        <!--                <div class="card-header">-->
        <!--                    <div class="card-img-top">-->
        <!--                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-travel.png">-->
        <!--                    </div>-->
        <!--                    <h4 class="card-title">-->
        <!--                        <h6 style="color:red;">Coming soon</h6>-->
        <!--                        ParkUpp Travel-->
        <!--                    </h4>-->
        <!--                </div>-->
        <!--                <div class="card-body">-->
        <!--                    <div class="card-subtitle">-->
        <!--                        List parking and valet services at airports, stations and harbours. ParkUpp promotes pre-travel-->
        <!--                        parking….parkers book and pay online.-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <div class="col-md-3">-->
        <!--            <div class="card w-100 m-3 rounded-3 coming-soon"-->
        <!--                 (click)="selectParkingType(parkingTypes.TRAILERS_CARAVANS_BOATS)">-->
        <!--                <div class="card-header">-->
        <!--                    <div class="card-img-top">-->
        <!--                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/trailers-caravans-boats.jpg">-->
        <!--                    </div>-->
        <!--                    <h4 class="card-title">-->
        <!--                        <h6 style="color:red;">Coming soon</h6>-->
        <!--                        ParkUpp Lifestyle-->
        <!--                    </h4>-->
        <!--                </div>-->
        <!--                <div class="card-body">-->
        <!--                    <div class="card-subtitle">-->
        <!--                        List parking suitable for boats, caravans, RV’s and trailers. Undercover or out . Parkers can-->
        <!--                        book for next day, monthly or annually. Depends on how short or long you would like to have-->
        <!--                        these parked in your bay.-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="col-md-3">
            <div class="card w-100 m-3 rounded-3" (click)="selectParkingType(parkingTypes.FLEX)">
                <div class="card-header">
                    <div class="card-img-top">
                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-flex.png" />
                    </div>
                    <h4 class="card-title">ParkUpp Flex</h4>
                </div>
                <div class="card-body">
                    <div class="card-subtitle">
                        Typically listed by property owners who have vacant parking for a couple of months while waiting for a new tenant. Parkers rent bays one month at a time, often at a discount to
                        compensate for flexible tenure.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row justify-content-center" *ngIf="authService.admin">
        <div class="col-md-3">
            <div class="card w-100 m-3 rounded-3" (click)="selectParkingType(parkingTypes.BOOKING)">
                <div class="card-header">
                    <div class="card-img-top">
                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-bookupp.png" />
                    </div>
                    <h4 class="card-title">ParkUpp Booking</h4>
                </div>
                <div class="card-body">
                    <div class="card-subtitle">Our new ParkUpp Booking product allows you facilitate private daily bookings for your complex or business parking facility.</div>
                </div>
            </div>
        </div>
        <!--        <div class="col-md-3">-->
        <!--            <div class="card w-100 m-3 rounded-3 coming-soon" (click)="selectParkingType(parkingTypes.TRUCKS)">-->
        <!--                <div class="card-header">-->
        <!--                    <div class="card-img-top">-->
        <!--                        <img class="img-fluid mb-3" alt="" src="assets/images/parking/parking-trucks.png">-->
        <!--                    </div>-->
        <!--                    <h4 class="card-title">-->
        <!--                        <h6 style="color:red;">Coming soon</h6>-->
        <!--                        ParkUpp Longhaul-->
        <!--                    </h4>-->
        <!--                </div>-->
        <!--                <div class="card-body">-->
        <!--                    <div class="card-subtitle">-->
        <!--                        If you own a truck stop or secure facility where drivers can shower, eat and sleep knowing that-->
        <!--                        they and their cargo is safe, list your facility here. Truckers can search, book and pay for-->
        <!--                        your facility when starting to feel weary ,from the road ,on an hours notice.-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</div>
